import {
  FILTER_RELATIVE_DATE_RANGE,
  FilterTypeEnum,
  SavedSearch,
  SavedSearchDto,
  SavedSearchFilter,
} from '@creditsights/api-ui-web';
import { SavedSearchFilterDto } from '../../../services/dtos/savedSearch.dto';
import { TagDto } from '../../../services/dtos/tags/tag.dto';
import { mapTagsIdsToTags } from '../../tags/utils/tags.mappers';

export const mapSavedSearchesDtoToModel = (
  savedSearches: SavedSearchDto[],
  tags: Record<string, TagDto>
): SavedSearch[] =>
  savedSearches.map((savedSearch) => ({
    id: savedSearch.id,
    name: savedSearch.name,
    keywords: savedSearch.keywords,
    filters: (savedSearch.filters && mapFiltersDtoToModel(savedSearch.filters, tags)) || [],
    dateRange: savedSearch.dateRange && {
      startDate: savedSearch.dateRange.startDate,
      endDate: savedSearch.dateRange.endDate,
      relativeRange: savedSearch.dateRange.relativeRange as FILTER_RELATIVE_DATE_RANGE,
    },
    createdAt: savedSearch.createdAt,
    updatedAt: savedSearch.updatedAt,
    pageName: savedSearch.pageName,
    sort: savedSearch.sort,
    tab: savedSearch.tab,
  }));

const mapFiltersDtoToModel = (filters: SavedSearchFilterDto[], tags: Record<string, TagDto>): SavedSearchFilter[] =>
  filters.map((filter) => ({
    filterType: filter.filterType as FilterTypeEnum,
    tags: mapTagsIdsToTags(filter.tags, tags),
  }));
